const CREAR = 1
const EDITAR = 2
const ELIMINAR = 3

export default Object.freeze({
  CREAR,
  EDITAR,
  ELIMINAR
})
